import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Button } from '~/shared/components/Button';
import { breakpoints } from '~/theme';

type FilterButtonProps = {
    removeAllElementFilter?: boolean;
};

export const FilterButton = styled(Button)<FilterButtonProps>(
    ({ theme }) => ({
        height: theme.lineHeights.wolf,
        borderColor: theme.colors.grey50,

        'div, span, svg': {
            marginRight: theme.space[1],
        },

        [breakpoints.sm]: {
            ':hover, :focus, :active': {
                borderColor: theme.colors.brandBlue,

                'div, span': {
                    colors: theme.colors.brandBlue,
                },
            },
        },
    }),
    ifProp('removeAllElementFilter', ({ theme }) => ({
        [breakpoints.sm]: {
            border: 'none',
            backgroundColor: theme.colors.brandBlue,

            ':hover, :focus, :active': {
                backgroundColor: theme.colors.brandBlue,
            },
        },
    })),
);

export const Container = styled.ul(({ theme }) => ({
    display: 'flex',
    gap: theme.space[1],
    msOverflowStyle: 'none',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&:scrollbar': {
        display: 'none',
    },
    whiteSpace: 'nowrap',
    width: '100%',
    order: 2,

    [breakpoints.sm]: {
        order: 1,
        flexWrap: 'wrap',
        overflowX: 'auto',
        whiteSpace: 'unset',
    },
}));
